<template>
  <div id="dashboard">
    <Navigation v-if="currentUser" v-on:setViewMode="setViewMode($event)"></Navigation>

    <div id="content">
      <!-- DASHBOARD TOOLS -->
      <nav class="nav" v-if="viewMode !== 'settings' && viewMode !== 'manageLists'">
        <a class="nav-item nav-link" @click="openCreatePostModal()" v-b-tooltip.hover title="Create Post"><i class="fas fa-plus-circle"></i></a>
        <a class="nav-item nav-link" @click="setViewMode('dashboardHome')" v-b-tooltip.hover title="Dashboard Home"><i class="far fa-home"></i></a>
        <a class="nav-item nav-link" @click="setViewMode('postsMasonry')" v-b-tooltip.hover title="Grid View"><i class="far fa-columns"></i></a>
        <a class="nav-item nav-link" @click="setViewMode('postsList')" v-b-tooltip.hover title="List View"><i class="far fa-th-list"></i></a>
        <a class="nav-item nav-link" @click="setViewMode('postsMap')" v-b-tooltip.hover title="Map View"><i class="far fa-map"></i></a>
        <a class="nav-item nav-link" @click="setViewMode('postsTimeline')" v-b-tooltip.hover title="Timeline View"><i class="far fa-calendar-alt"></i></a>
        <div class="share-view">
          <button class="btn btn-primary btn-sm" @click="openShareModal()" v-if="viewMode == 'postsMap' || viewMode == 'postsTimeline' || viewMode == 'dashboardHome' || viewMode == 'postsMasonry'"><i class="fas fa-share"></i> Share View</button>
        </div>
      </nav>

      <!-- DASHBOARD SCREENS -->
      <!-- Dashboard Home -->
      <DashboardHome v-if="viewMode === 'dashboardHome'"></DashboardHome>
      <!-- Posts Feed in Masonry Style -->
      <PostsMasonry v-if="viewMode === 'postsMasonry'" v-on:openPostModal="openPostModal($event)"></PostsMasonry>
      <!-- Posts Feed in List Style -->
      <PostsList v-if="viewMode === 'postsList'" v-on:openPostModal="openPostModal($event)"></PostsList>
      <!-- Posts Feed in Map Style -->
      <PostsMap v-if="viewMode === 'postsMap'" v-on:openPostModal="openPostModal($event)"></PostsMap>
      <!-- Posts Feed in Timeline Style -->
      <PostsTimeline v-if="viewMode === 'postsTimeline'" v-on:openPostModal="openPostModal($event)"></PostsTimeline>
      <!-- Lists -->
      <ManageLists v-if="viewMode === 'manageLists'" v-on:setViewMode="setViewMode($event)"></ManageLists>
      <!-- Settings -->
      <Settings v-if="viewMode === 'settings'"></Settings>

      <!-- DASHBOARD MODALS -->
      <!-- Create Post Modal -->
      <CreatePostModal v-if="showCreatePostModal" :fullPost='fullPost' v-on:closeCreatePostModal="closeCreatePostModal()"></CreatePostModal>
      <!-- The Post Modal -->
      <PostModal v-if="showPostModal" :fullPost='fullPost' v-on:closePostModal="closePostModal()" v-on:openEditPostModal="openEditPostModal($event)"></PostModal>
      <!-- Share Modal -->
      <ShareModal v-if="showShareModal" v-on:closeShareModal="closeShareModal()" :viewMode="viewMode"></ShareModal>

    </div><!-- /#content -->
  </div><!-- /#dashboard -->
</template>

<script>
  import { mapState } from 'vuex'
  import CreatePostModal from './CreatePostModal.vue'
  import DashboardHome from './DashboardHome.vue'
  import PostsMasonry from './PostsMasonry.vue'
  import PostsList from './PostsList.vue'
  import PostsMap from './PostsMap.vue'
  import PostsTimeline from './PostsTimeline.vue'
  import PostModal from './PostModal.vue'
  import Navigation from './Navigation.vue'
  import Settings from './Settings.vue'
  import ManageLists from './ManageLists.vue'
  import ShareModal from './ShareModal.vue'

  export default {
    components: { DashboardHome, PostsMasonry, PostsList, PostsMap, PostsTimeline, CreatePostModal, PostModal, Navigation, Settings, ManageLists, ShareModal },
    computed: {
      ...mapState(['currentUser'])
    },
    data() {
      return {
        viewMode: 'dashboardHome',
        showCreatePostModal: false,
        showPostModal: false,
        showShareModal: false,
        fullPost: {}
      }
    },
    created: function () {
      this.$store.dispatch('getMyPosts')
      if (this.$route.params.mode == 'lists') {
        this.viewMode = 'manageLists'
      }
      if (this.$route.params.mode == 'map') {
        this.viewMode = 'postsMap'
      }
      if (this.$route.params.mode == 'timeline') {
        this.viewMode = 'postsTimeline'
      }
      if (this.$route.params.mode == 'grid') {
        this.viewMode = 'postsMasonry'
      }
    },
    methods: {
      setViewMode(viewMode) {
        // Set route based on view mode
        if (viewMode == 'postsMap') {
          this.$router.push('/dashboard/map')
        }
        if (viewMode == 'postsTimeline') {
          this.$router.push('/dashboard/timeline')
        }
        if (viewMode == 'dashboardHome') {
          this.$router.push('/dashboard')
        }
        if (viewMode == 'postsMasonry') {
          this.$router.push('/dashboard/grid')
        }
        this.viewMode = viewMode
      },
      openCreatePostModal() {
        this.showCreatePostModal = true
        this.fullPost = null
      },
      closeCreatePostModal() {
        this.showCreatePostModal = false
        this.$router.push('/dashboard/grid')
      },
      openPostModal(postData) {
        this.fullPost = postData
        this.showPostModal = true
      },
      closePostModal() {
        this.showPostModal = false
      },
      openEditPostModal(postData) {
        this.fullPost = postData
        this.showCreatePostModal = true
      },
      closeShareModal() {
        this.showShareModal = false
      },
      openShareModal() {
        this.showShareModal = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue